var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.091 1.34886H12.219C12.1044 0.585393 11.4457 0 10.6502 0H7.3504C6.55498 0 5.89628 0.585393 5.78162 1.34886H1.90918C1.35689 1.34886 0.90918 1.79658 0.90918 2.34886V13.8337C0.90918 14.386 1.35689 14.8337 1.90918 14.8337H16.091C16.6433 14.8337 17.091 14.386 17.091 13.8337V2.34886C17.091 1.79658 16.6433 1.34886 16.091 1.34886ZM9 12.1366C11.2342 12.1366 13.0455 10.3254 13.0455 8.09114C13.0455 5.85689 11.2342 4.04568 9 4.04568C6.76576 4.04568 4.95455 5.85689 4.95455 8.09114C4.95455 10.3254 6.76576 12.1366 9 12.1366ZM8.9999 10.7883C10.4894 10.7883 11.6969 9.58078 11.6969 8.09129C11.6969 6.60179 10.4894 5.39432 8.9999 5.39432C7.51041 5.39432 6.30293 6.60179 6.30293 8.09129C6.30293 9.58078 7.51041 10.7883 8.9999 10.7883Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photoIcon.88dff85db14399b838dc2d07e0b2b599.svg";
export { ForwardRef as ReactComponent };